<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <div class="close" v-on:click="close(false)"></div>
        <div class="bgCnt"
          :class="{loading: loading}">
          <img :src="imgUri"
            v-if="!loading">
        </div>
        <div v-if="loading" class="loadingCnt">
          <h4>Membuat gambar</h4>
          <p>Mohon tunggu, sedang membuat gambar karakter kamu...</p>
        </div>
        <div v-else>
          <h4>Bagikan melalui</h4>
          <p>Jangan lupa tambahkan hashtag <span>#BodyKeyChallenge2023</span> pada post
          Instagram atau Twitter kamu.</p>
          <div class="selectorCnt">
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareEncoded}`"
              target="_blank" class="selectorItem">
              <img src="../assets/i-facebook-2.png">
              <h4>Post</h4>
            </a>
            <a :href="`https://twitter.com/intent/tweet?url=${shareEncoded}&text=${escapedTitle}&related=Amway,Boydkey,Nutrilite,BkChallenge2023`"
              target="_blank" class="selectorItem">
              <img src="../assets/i-twitter-2.png">
              <h4>Tweet</h4>
            </a>
            <a :href="`https://api.whatsapp.com/send/?phone&text=${waText}&app_absent=0`"
              target="_blank" class="selectorItem">
              <img src="../assets/i-wa.png">
              <h4>Send</h4>
            </a>
            <div class="selectorItem" v-on:click="openIg">
              <img src="../assets/i-instagram.png">
              <h4>Instagram</h4>
            </div>
            <a :href="`mailto:?subject=${escapedTitleOnly}&body=${emailBody}`"
              target="_blank" class="selectorItem">
              <img src="../assets/envelope-2.png">
              <h4>Email</h4>
            </a>
          </div>
          <div class="shareLink">
            {{shareUriDisplay}}
            <div class="copy" v-on:click="copyToClp(shareUriDisplay)">SALIN</div>
          </div>
          <div class="downloadCnt">
            <a :href="imgUri" class="download" target="_blank"
              download>Download Gambar</a>
          </div>
        </div>
      </div>
      <Confirmation ref="confirmDialog"/>
      <Snackbar ref="snackbar"/>
      <IgDialog ref="igDialog"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import IgDialog from '@/components/IgDialog.vue';

export default {
  name: 'shareDialog',
  components: { Confirmation, Snackbar, IgDialog },
  data() {
    return {
      show: false,
      next: null,
      shareUriDisplay: '',
      escapedMedia: '',
      shareEncoded: '',
      escapedTitle: '',
      waText: '',
      emailBody: '',
      loading: true,
      imgUri: '',
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.show = true;
      this.$http.get(this.$config.uri('user/share/create')).then((r) => {
        this.shareUriDisplay = `${this.$config.cdnUri}share/s6/${r.data.uuid}`;
        this.shareEncoded = escape(this.shareUriDisplay);
        this.escapedTitle = escape('Karakter Saya selama mengikuti #BodyKeyChallenge2023');
        this.waText = escape(`Lihat karakter Saya selama mengikuti #BodyKeyChallenge2023 di ${this.shareUriDisplay}`);
        this.emailBody = escape(`Hi!\n\nLihat karakter Saya selama mengikuti #BodyKeyChallenge2023 di ${this.shareUriDisplay}`);
        this.escapedTitleOnly = escape('Karakter Saya Selama Mengikuti #BodyKeyChallenge2023');
        this.imgUri = (r.data.status === 200) ? r.data.uri : '';
        this.loading = false;
      });
    },
    openIg() {
      this.$refs.igDialog.open();
      // setTimeout(() => {
      //   window.location.href = 'instagram://story-camera';
      // }, 400);
    },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Link copied to clipboard.' });
    },
    close(b) {
      if (!this.loading) {
        this.show = false;
        return;
      }
      this.$refs.confirmDialog.open({
        title: 'Batalkan Membuat Gambar',
        desc: 'Apakah kamu yakin ingin membatalkan membuat gambar untuk dibagikan?',
        action: 'Batalkan',
        cancelLabel: 'Kembali',
      }, (b2) => {
        if (!b2) return;
        this.show = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    @media (max-width: 768px) {
      top: 60px;
    }
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 580px;
      text-align: center;
      .uploading{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: #fff;
        background-size: 46px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/loading.svg);
        z-index: 9;
      }
      .close{
        width: 36px; height: 36px;
        border-radius: 50%;
        position: absolute;
        right: 10px; top: 10px;
        background-image: url(../assets/close.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .7;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: rgba(0,0,0,.2);
          opacity: .6;
        }
      }
      @media (max-width: 680px) {
        width: calc(100% - 20px);
        box-sizing: border-box;
        padding: 30px 30px 20px;
      }
      .selectorCnt{
        display: flex;
        justify-content: center;
        @media (max-width: 680px) {
          justify-content: space-between;
        }
        .selectorItem{
          padding: 14px 34px 10px;
          border: #fff 1px solid;
          border-radius: 5px;
          transition: all .2s ease;
          position: relative;
          text-align: center;
          color: #444;
          @media (max-width: 680px) {
            padding: 14px 10px 4px;
          }
          &:hover{
            opacity: 1;
            // border-color: #f5f5f5;
            // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #006519;
            font-size: 12px;
          }
          img{
            height: 30px;
            margin-bottom: 5px;
          }
        }
      }
      h4{
        margin: 0;
        font-size: 24px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #444;
        font-weight: bold;
        font-size: 18px;
        text-align: center;
      }
      p{
        margin: 0 0 4px;
        font-size: 14px;
        span{
          color: #006519;
          font-weight: bold;
        }
      }
      .loadingCnt{
        text-align: center;
        h4{
          margin: 0 0 2px;
          color: #767676;
          font-size: 19px;
        }
        p{
          margin: 0;
          font-size: 15px;
          color: #767676;
        }
      }
      .bgCnt{
        text-align: center;
        height: 220px;
        overflow: hidden;
        background-color: #f5f5f5;
        margin-bottom: 14px;
        background-position: center;
        background-size: 46px auto;
        background-repeat: no-repeat;
        &.loading{
          background-color: #fff;
          background-image: url(../assets/loading.svg);
        }
        img{
          width: 100%;
          max-width: 180px;
        }
      }
      .downloadCnt{
        text-align: center;
        padding-bottom: 10px;
      }
      .download{
        background-color: #8EC642;
        color: #fff;
        padding: 10px 20px;
        box-sizing: border-box;
        border-radius: 3px;
        // box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        display: inline-block;
        text-align: center;
        // font-weight: bold;
        margin-top: 10px;
        padding-left: 48px;
        position: relative;
        &:before{
          position: absolute;
          content: "";
          left: 14px; top: 5px;
          width: 24px; height: 24px;
          background-image: url(../assets/download-o-white.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .shareLink{
        margin: 10px 34px 4px;
        background-color: #f5f5f5;
        border: #ccc 1px solid;
        border-radius: 3px;
        color: #222;
        padding: 10px 12px;
        position: relative;
        padding-right: 80px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        // display: none;
        @media (max-width: 680px) {
          margin: 10px 0 4px;
        }
        .copy{
          position: absolute;
          right: 4px; top: 4px;
          font-weight: 600;
          color: #01641a;
          padding: 6px 10px;
          border-radius: 3px;
          cursor: pointer;
          &:hover{
            background-color: #ddd;
          }
        }
      }
    }
  }
</style>
